"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRequestBuilder = void 0;
const react_1 = require("react");
const system_1 = require("@snort/system");
const shared_1 = require("@snort/shared");
/**
 * Send a query to the relays and wait for data
 */
const useRequestBuilder = (system, type, rb) => {
    const subscribe = (onChanged) => {
        if (rb) {
            const q = system.Query(type, rb);
            const release = q.feed.hook(onChanged);
            q.uncancel();
            return () => {
                q.cancel();
                release();
            };
        }
        return () => {
            // noop
        };
    };
    const getState = () => {
        const q = system.GetQuery(rb?.id ?? "");
        if (q) {
            return (0, shared_1.unwrap)(q).feed?.snapshot;
        }
        return system_1.EmptySnapshot;
    };
    return (0, react_1.useSyncExternalStore)(v => subscribe(v), () => getState());
};
exports.useRequestBuilder = useRequestBuilder;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlUmVxdWVzdEJ1aWxkZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvdXNlUmVxdWVzdEJ1aWxkZXIudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLGlDQUE2QztBQUM3QywwQ0FBeUc7QUFDekcsMENBQXVDO0FBRXZDOztHQUVHO0FBQ0gsTUFBTSxpQkFBaUIsR0FBRyxDQUN4QixNQUF1QixFQUN2QixJQUF1QixFQUN2QixFQUF5QixFQUN6QixFQUFFO0lBQ0YsTUFBTSxTQUFTLEdBQUcsQ0FBQyxTQUFxQixFQUFFLEVBQUU7UUFDMUMsSUFBSSxFQUFFLEVBQUU7WUFDTixNQUFNLENBQUMsR0FBRyxNQUFNLENBQUMsS0FBSyxDQUFTLElBQUksRUFBRSxFQUFFLENBQUMsQ0FBQztZQUN6QyxNQUFNLE9BQU8sR0FBRyxDQUFDLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsQ0FBQztZQUN2QyxDQUFDLENBQUMsUUFBUSxFQUFFLENBQUM7WUFDYixPQUFPLEdBQUcsRUFBRTtnQkFDVixDQUFDLENBQUMsTUFBTSxFQUFFLENBQUM7Z0JBQ1gsT0FBTyxFQUFFLENBQUM7WUFDWixDQUFDLENBQUM7U0FDSDtRQUNELE9BQU8sR0FBRyxFQUFFO1lBQ1YsT0FBTztRQUNULENBQUMsQ0FBQztJQUNKLENBQUMsQ0FBQztJQUNGLE1BQU0sUUFBUSxHQUFHLEdBQTZCLEVBQUU7UUFDOUMsTUFBTSxDQUFDLEdBQUcsTUFBTSxDQUFDLFFBQVEsQ0FBQyxFQUFFLEVBQUUsRUFBRSxJQUFJLEVBQUUsQ0FBQyxDQUFDO1FBQ3hDLElBQUksQ0FBQyxFQUFFO1lBQ0wsT0FBTyxJQUFBLGVBQU0sRUFBQyxDQUFDLENBQUMsQ0FBQyxJQUFJLEVBQUUsUUFBb0MsQ0FBQztTQUM3RDtRQUNELE9BQU8sc0JBQXlDLENBQUM7SUFDbkQsQ0FBQyxDQUFDO0lBQ0YsT0FBTyxJQUFBLDRCQUFvQixFQUN6QixDQUFDLENBQUMsRUFBRSxDQUFDLFNBQVMsQ0FBQyxDQUFDLENBQUMsRUFDakIsR0FBRyxFQUFFLENBQUMsUUFBUSxFQUFFLENBQ2pCLENBQUM7QUFDSixDQUFDLENBQUM7QUFFTyw4Q0FBaUIifQ==